<div class="main-content page-container bg-gray-100">
  <div class="side-bar bg-gray-50 pt-10 pe-8">
    <div class="mb-8">
      <div *ngIf="tituloTag"
        class="w-fit border-sm-full {{corBordaTag}} rounded-xl py-1 px-3">
        <span class="{{corTextoTag}} text-body-md font-regular">
          {{ tituloTag }}
        </span>
      </div>
    </div>

   <!-- Nacional -->
    <div *ngIf="isNivelNacional" class="ilustration-container flex gap-4">
      <img [src]="imagemFundo" alt="ilustração" />
      <div class="flex flex-col justify-center gap-1">
        <div>
          <span class="text-charcoal-800 text-body-lg">Plano Nacional / </span>
        </div>
        <div>
          <span class="text-blue-500 text-body-xlg text-bold">
            {{ pais }}, {{ ano }}
          </span>
        </div>
      </div>
    </div>

    <!-- Estadual -->
    <div *ngIf="isNivelEstadual" class="ilustration-container flex gap-4">
      <img [src]="imagemFundo" alt="ilustração" />
      <div class="flex flex-col justify-center gap-1">
        <div>
          <span class="text-charcoal-800 text-body-lg">{{ redeSelecionada }} / </span>
          <span class="text-charcoal-800 text-body-lg">{{ pais }} / </span>
        </div>
        <div>
          <span class="text-blue-500 text-body-xlg text-bold">
            {{ estado | titlecase }}, {{ ano }}
          </span>
        </div>
      </div>
    </div>

    <!-- Municipal -->
    <div *ngIf="isNivelMunicipal" class="ilustration-container flex gap-4">
      <img [src]="imagemFundo" alt="ilustração" />
      <div class="flex flex-col justify-center gap-1">
        <div>
          <span class="text-charcoal-800 text-body-lg">{{ redeSelecionada }} / </span>
          <span class="text-charcoal-800 text-body-lg">{{ pais }} / </span>
          <span class="text-charcoal-800 text-body-lg">{{ estado | titlecase }} ({{ siglaEstado}}) / </span>
        </div>
        <div>
          <span class="text-blue-500 text-body-xlg text-bold">
            {{ cidade | titlecase }}, {{ ano }}
          </span>
        </div>
      </div>
    </div>

    <div class="resultados-wrapper">
      <h1 class="text-charcoal-800 text-heading-md font-bold m-0 mb-2">Indicadores</h1>
      <p class="text-charcoal-800 text-body-lg font-regular m-0">
        Indicadores sociais, educacionais e financeiros da localidade
      </p>
    </div>

    <div class="actions-container flex flex-col gap-6 mt-8">
      <div *ngIf="rotaResultado"
           [routerLink]="rotaResultado"
           class="action flex gap-2 items-center">
        <img src="assets/icons/arrow-left.svg" alt="voltar" class="icon w-4 h-4" />
        <span class="text-charcoal-600 text-body-lg font-regular">Voltar ao resultado</span>
      </div>

      <div *ngIf="rotaFiltroLocalidade"
           [routerLink]="rotaFiltroLocalidade"
           class="action flex gap-2 items-center">
        <img src="assets/icons/localizacao.svg" alt="Localidade" class="icon w-4 h-4" />
        <span class="text-charcoal-600 text-body-lg font-regular">Alterar localidade</span>
      </div>

      <div *ngIf="rotaDownloadIndicadores">
        <a *ngIf="rotaDownloadIndicadores.tipo === 'rota'" 
          [href]="urlBase + '/' + rotaDownloadIndicadores.rota" 
          class="action flex gap-2 items-center"
          style="text-decoration: none;">
          <img src="assets/icons/download.svg" alt="Download" class="icon w-4 h-4" />
          <span class="text-charcoal-600 text-body-lg font-regular">Download</span>
        </a>
        
        <a *ngIf="rotaDownloadIndicadores.tipo === 'acao'" 
          (click)="rotaDownloadIndicadores.acao()" 
          class="action flex gap-2 items-center cursor-pointer"
          style="text-decoration: none;">
          <img src="assets/icons/download.svg" alt="Download" class="icon w-4 h-4" />
          <span class="text-charcoal-600 text-body-lg font-regular">Download</span>
        </a>
      </div>

      <div *ngIf="editavel"
           (click)="abrirEdicaoSimulacao()"
           class="action flex gap-2 items-center">
        <img src="assets/icons/pen.svg" alt="Editar" class="icon w-4 h-4" />
        <span class="text-red-500 text-body-lg font-regular">Editar parâmetros da simulação</span>
      </div>

      <div routerLink="{{rotaApresentacao}}"
           class="action flex gap-2 items-center">
        <img src="assets/icons/house.svg" alt="Início" class="icon w-4 h-4" />
        <span class="text-charcoal-600 text-body-lg font-regular">Voltar ao início</span>
      </div>
    </div>
  </div>

  <div class="pt-12 pb-30">
    <router-outlet></router-outlet>
    <div class="como-citar">
      <div class="w-full text-orange-400 mt-16 text-bold text-heading-md">
        Como citar esta página?
      </div>
      <div class="divCite w-full pt-4">
      <div class="textoComoCitar w-full text-body-lg text-charcoal-600 p-2 rounded-tl-xs rounded-bl-xs">{{ textoComoCitar }}</div>
      <div>
        <button class="buttonCopy bg-orange-400 rounded-tr-xs rounded-br-xs border-sm-full border-orange-400"
          (click)="copiarParaAreaDeTransferencia()">
            <img alt="rows" src="../../../assets/imagens/copy.svg">
            <span class="text-body-lg text-regular text-gray-50">Copiar</span>
        </button>
      </div>
    </div>
    
  </div>
</div>
